/* eslint-disable react/jsx-props-no-spreading */
import { Icon, type LayoutProps } from '@chakra-ui/react';
import { darkenColor } from '@/client/utils/colors/darkenColor';

interface ExpertsColorChangeIconProps {
  /** The color of the icon. */
  color?: string;
  /** The size of the icon. */
  boxSize?: LayoutProps['boxSize'];
}

export default function ExpertsColorChangeIcon({
  color = '#FF9B99',
  boxSize = 5,
  ...props
}: ExpertsColorChangeIconProps & Omit<React.ComponentProps<typeof Icon>, 'children'>) {
  return (
    <Icon viewBox="0 0 18 19" boxSize={boxSize} {...props}>
      <ellipse cx="9" cy="9.06111" rx="9" ry="9.06111" fill={color} />

      <path
        d="M0.236328 11.2069C0.371913 11.7604 0.558628 12.3104 0.804916 12.8473C2.88923 17.3901 8.23687 19.3724 12.7492 17.2742C16.3528 15.5986 18.3319 11.8273 17.9225 8.06255C14.2431 6.59872 11.9282 8.05916 10.4288 10.1658C7.51233 14.2631 2.50407 13.8507 0.260623 11.2207C0.252421 11.2168 0.244527 11.2108 0.236328 11.2069Z"
        fill={darkenColor(color)}
        fillOpacity="0.5"
        style={{ mixBlendMode: 'luminosity' }}
      />
    </Icon>
  );
}
